import React, { Component } from 'react'

class NotFound extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <p>Not Found</p>
        </div>
      </section>
    )
  }
}

export default NotFound